import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const PersonaliseExperience = ({ title, style, data, subtitle , avatarName}) => {
  const navigate = useNavigate();

  const gotoBackPage = ()=>{
   { avatarName ? navigate("/personalise", { state: { avatarName  } }) : navigate(-1)}
   
  }
  return (
    <div style={{ width: '50%', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)', padding: '25px',borderRadius: '10px' }}>
      <div style={{  marginBottom: '10px'}}><IoIosArrowBack onClick={gotoBackPage} style={{fontSize : '25px',cursor:'pointer'}}/></div>
      <div className="py-2">
        {/* Progress Bar */}
        <div className="progress mb-4">
          <div
            className="progress-bar"
            role="progressbar"
            style={style}
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <h4 className="mb-3">{title}</h4>
        <p className="text-muted">{subtitle}</p>

        {data}

        {/* Next Button */}
      </div>
    </div>
  );
};

export default PersonaliseExperience;
